"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveRegionBlock = void 0;

var _react = _interopRequireDefault(require("react"));

var _screenReaderOnly = require("../screen-reader-only");

var _core = require("@emotion/core");

var LiveRegionBlock = function LiveRegionBlock(_ref) {
  var children = _ref.children,
      role = _ref.role,
      _ref$ariaAtomic = _ref['aria-atomic'],
      ariaAtomic = _ref$ariaAtomic === void 0 ? true : _ref$ariaAtomic,
      ariaLive = _ref['aria-live'];
  return (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    role: role,
    "aria-atomic": ariaAtomic,
    "aria-live": ariaLive,
    "data-test-component": "StencilLiveRegion"
  }, !!children ? children : '');
};

exports.LiveRegionBlock = LiveRegionBlock;